import { createEmitAndSemanticDiagnosticsBuilderProgram } from "typescript";
import Http, { BaseResponse } from "../../../services/Http";

import {
  JudgmentIntegrationImportCommand,
  ExternalJudgmentImportCommand,
  JudgmentIntegrationImportResponse,
  ExternalJudgmentImportResponse,
  GetJudgmentIntegrationByIdCommand,
  GetJudgmentIntegrationByIdResponse,
  GetAllJudgementIntegrationsResponse,
  SaveJudgmentIntegrationCommand,
  SaveJudgmentIntegrationResponse,
  JudgmentIntegrationTransposerCommand,
  JudgmentIntegrationTransposerResponse,
  GenerateNoticeCommand,
  GenerateNoticeResponse,
  GenerateDocketEventsCommand,
  GenerateDocketEventsResponse,
  SatisfactionsTransposerCommand,
  SatisfactionsTransposerResponse,
  DeleteJudgmentIntegrationCommand,
  DeleteJudgmentIntegrationResponse,
  SatisfactionCaseCreateRequestModel,
} from "../types/JudgmentIntegrationTypes";

export default {
  getJudgmentById: async (
    id: number
  ): Promise<GetJudgmentIntegrationByIdResponse> => {
    var command: GetJudgmentIntegrationByIdCommand = {
      judgmentIntegrationID: id,
    };
    var response = await Http.get<GetJudgmentIntegrationByIdResponse>({
      data: command,
      url: "JudgmentIntegration/GetJudgmentIntegration",
      waitMessage: "Fetching Data...",
    });

    return response;
  },

  getAllJudgementIntegrations:
    async (): Promise<GetAllJudgementIntegrationsResponse> => {
      var response = await Http.get<GetAllJudgementIntegrationsResponse>({
        url: "JudgmentIntegration/GetAllJudgmentIntegrations",
        waitMessage: "Fetching Data...",
      });

      return response;
    },

  importJudgments: async (
    command: JudgmentIntegrationImportCommand
  ): Promise<JudgmentIntegrationImportResponse> => {
    let response = await Http.post<JudgmentIntegrationImportResponse>({
      url: "JudgmentIntegration/ImportJudgments",
      data: command,
      waitMessage: "Importing Files...",
    });
    return response;
  },

  importExternalJudgments: async (command: ExternalJudgmentImportCommand): Promise<ExternalJudgmentImportResponse> => {
    let response = await Http.post<ExternalJudgmentImportResponse>({
      url: "JudgmentIntegration/ImportExternalJudgments",
      data: command,
      waitMessage: "Importing Data...",
    });
    return response;
  },

  saveJudgmentIntegration: async (
    command: SaveJudgmentIntegrationCommand
  ): Promise<SaveJudgmentIntegrationResponse> => {
    let response = await Http.post<SaveJudgmentIntegrationResponse>({
      url: "JudgmentIntegration/SaveJudgmentIntegration",
      data: command,
      waitMessage: "Saving...",
    });

    return response;
  },

  deleteJudgmentIntegration: async (
    command: DeleteJudgmentIntegrationCommand
  ): Promise<DeleteJudgmentIntegrationResponse> => {
    let response = await Http.post<DeleteJudgmentIntegrationResponse>({
      url: "JudgmentIntegration/DeleteJudgmentIntegration",
      data: command,
      waitMessage: "Deleting...",
    });

    return response;
  },

  createCases: async (
    command: JudgmentIntegrationTransposerCommand
  ): Promise<JudgmentIntegrationTransposerResponse> => {
    let response = await Http.post<JudgmentIntegrationTransposerResponse>({
      url: "JudgmentIntegration/CreateJudgmentCases",
      data: command,
      waitMessage: "Creating Cases...",
    });

    return response;
  },


  createSatisfactionCasesAndDockets: async (
    command: SatisfactionCaseCreateRequestModel
  ): Promise<JudgmentIntegrationTransposerResponse> => {
    let response = await Http.post<JudgmentIntegrationTransposerResponse>({
      url: "JudgmentIntegration/CreateSatisfactionCasesAndDockets",
      data: command,
      waitMessage: "Creating Cases for Satisfaction(s)...",
    });

    return response;
  },

  createSatisfactions: async (
    command: SatisfactionsTransposerCommand
  ): Promise<SatisfactionsTransposerResponse> => {
    let response = await Http.post<SatisfactionsTransposerResponse>({
      url: "JudgmentIntegration/CreateSatisfactions",
      data: command,
      waitMessage: "Creating Satisfactions...",
    });

    return response;
  },

  generateNotices: async (
    command: GenerateNoticeCommand
  ): Promise<GenerateNoticeResponse> => {
    let response = await Http.post<GenerateNoticeResponse>({
      url: "JudgmentIntegration/GenerateIntegrationNotice",
      data: command,
      waitMessage: "Generating Notices...",
    });
    return response;
  },

  generateDocketEvents: async (
    command: GenerateDocketEventsCommand
  ): Promise<GenerateDocketEventsResponse> => {
    let response = await Http.post<GenerateDocketEventsResponse>({
      url: "JudgmentIntegration/GenerateJudgmentDocketEvent",
      data: command,
      waitMessage: "Generating Docket Entries...",
    });
    return response;
  },

  getAllDocuments: async (
    command: GenerateNoticeCommand
  ): Promise<GenerateNoticeResponse> => {
    let response = await Http.post<GenerateNoticeResponse>({
      url: "JudgmentIntegration/DownloadAllJudgmentFiles",
      data: command,
      waitMessage: "Downloading Files..."
    });
    return response;
  }
};
